import { PriceTable } from '../../price-tables/price-table.types';
import { OfflineDatabasePriceTable } from '../database/offlineDatabase/types/offlineDatabasePriceTable.types';

export class OfflinePriceTableTransformers {
  static toOnlinePriceTable(priceTable: OfflineDatabasePriceTable): PriceTable {
    return {
      active: true,
      id: priceTable.id,
      code: priceTable.code,
      name: priceTable.name,
      defaultTable: priceTable.defaultTable,
    };
  }
}
